import React from 'react'

// Gradient intro card at the top of each dashboard page, styled like the home balance card
const PageHero = ({ icon, eyebrow, title, description, children }) => (
  <div className="ud-page-hero">
    <div className="ud-page-hero-main">
      {icon && <span className="ud-page-hero-icon">{icon}</span>}
      <div className="ud-page-hero-text">
        {eyebrow && <p className="ud-page-hero-eyebrow">{eyebrow}</p>}
        <h1 className="ud-page-hero-title">{title}</h1>
        {description && <p className="ud-page-hero-desc">{description}</p>}
      </div>
    </div>
    {children && <div className="ud-page-hero-aside">{children}</div>}
  </div>
)

export default PageHero
